module.exports = __webpack_public_path__ + "static/img/list-3.f07ac4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/list-3.png
// module id = s55J
// module chunks = 1